<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'sample-request-list'"
    :loadDataGrid="loaded"
    ref="sample-request-list"
    v-if="loaded"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../../templates/transaction-list";
import { FeatureStorage } from "../../../_services/storage";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Sample Requests",
        ScreenName: "Sample Requests",
        // selectedIndex: GetIndexByTabName("All"),
        // tabs: SalesOrderTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CustomerSampleRequestList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              // select: [],
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Sample Requests",
                message: "Get Started, Add Sample Requests",
              },
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/sample-request/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "SampleRequests",
                  "create"
                ),
              },
            ],
            filterOnEnter: true,
          },
          columns: [
            {
              screenField: "SampleRequest",
              label: "Request",
              type: "Integer",
              filterIndex: 0,
              width: ColumnWidth.SampleRequest.width,
              minWidth: ColumnWidth.SampleRequest.minWidth,
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              forceWidth: true,
            },

            {
              screenField: "DateCreated",
              label: "Date",
              filterLabel: "Date",
              filterIndex: 3,
              width: ColumnWidth.Date.width,
              maxWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "Customer",
              filterIndex: 1,
              allowHiding: false,
            },
            {
              screenField: "CustomerContact",
              type: "Text",
              filterIndex: 2,
              width: ColumnWidth.CustomerContact.width,
              maxWidth: ColumnWidth.CustomerContact.minWidth,
              exportFields: undefined,
              cellTemplate: false,
              cellTemplateRecord: false,
              dataField: "ContactName",
            },
            {
              screenField: "Date",
              dataField: "DateChanged",
              label: "Last Update",
            },

            {
              screenField: "OrderStatus",
              dataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 4,
              dataSourceConfig: {
                data: [
                  "Cancelled",
                  "Complete",
                  "Notified",
                  "Pending",
                  "Prepared",
                  "Sent",
                ],
              },
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "SampleRequest",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "SampleRequest",
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "OrderStatus" &&
        e.column.screenField != "GridRecordEmail" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordPrint"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "sample-request",
          mode: "review",
          idProperty: "SampleRequest",
        });
      }
    },
  },

  async created() {
    this.setLoading = true;
    this.loaded = true;
  },
};
</script>

<style lang="scss"></style>
